import React, { useContext, useState, useRef } from 'react';

type ContextType = {
  ctxHex: CanvasRenderingContext2D | null;
  setCtxHex: (ctxHex: CanvasRenderingContext2D) => void;
  bigHexPath: string | null;
  setBigHexPath: (bigHexPath: string) => void;
  features: any;
  setFeatures: (activeHexFeatures: any) => void;
  sqmtArea: number | null;
  setSqmtArea: (sqmtArea: number | null) => void;
  isBigHexSelected: boolean;
  isBigHexSelectedRef: React.MutableRefObject<boolean>;
  setIsBigHexSelected: (isBigHexSelected: boolean) => void;
  isBigHexViewActive: boolean;
  isBigHexViewActiveRef: React.MutableRefObject<boolean>;
  setIsBigHexViewActive: (isBigHexViewActive: boolean) => void;
  miniHexDominantFeature: string;
  setMiniHexDominantFeature: (miniHexDominantFeature: string) => void;
  activeHexCoords: any[];
  setActiveHexCoords: (activeHexCoords: any[]) => void;
};

type Props = {
  children: React.ReactNode;
};

export const ActiveHexContextProvider = ({ children }: Props): JSX.Element => {
  const [ctxHex, setCtxHex] = useState<CanvasRenderingContext2D | null>(null);
  const [bigHexPath, setBigHexPath] = useState<string | null>(null);
  const [features, setFeatures] = useState<any>(null);
  const [sqmtArea, setSqmtAreaTemp] = useState<number | null>(null);
  const [isBigHexSelected, _setIsBigHexSelected] = useState<boolean>(false);
  const [isBigHexViewActive, _setIsBigHexViewActive] = useState<boolean>(false);
  const [miniHexDominantFeature, setMiniHexDominantFeature] =
    useState<string>('');
  const [activeHexCoords, setActiveHexCoords] = useState<any[]>([]);

  const isBigHexSelectedRef = useRef(isBigHexSelected);
  const isBigHexViewActiveRef = useRef(isBigHexViewActive);

  const setIsBigHexSelected = (data: boolean) => {
    isBigHexSelectedRef.current = data;
    _setIsBigHexSelected(data);
  };
  const setIsBigHexViewActive = (data: boolean) => {
    isBigHexViewActiveRef.current = data;
    _setIsBigHexViewActive(data);
  };

  const setSqmtArea = (sqmtArea: number | null) => {
    if (sqmtArea) {
      setSqmtAreaTemp(Math.ceil(sqmtArea));
    } else setSqmtAreaTemp(0);
  };

  const value = {
    ctxHex,
    setCtxHex,
    features,
    setFeatures,
    bigHexPath,
    setBigHexPath,
    sqmtArea,
    setSqmtArea,
    isBigHexSelected,
    isBigHexSelectedRef,
    setIsBigHexSelected,
    isBigHexViewActive,
    isBigHexViewActiveRef,
    setIsBigHexViewActive,
    miniHexDominantFeature,
    setMiniHexDominantFeature,
    activeHexCoords,
    setActiveHexCoords,
  };

  return (
    <ActiveHexContext.Provider value={value}>
      {children}
    </ActiveHexContext.Provider>
  );
};

export const ActiveHexContext = React.createContext({} as ContextType);
export const useActiveHexContext = (): ContextType =>
  useContext(ActiveHexContext);
